import React from 'react';
import PropTypes from 'prop-types';
import { schedulePropTypes } from 'constants/propTypes';

import Badge from 'components/Badge';
import Message from 'components/Message';

import ClassSmartSpotStatus from './ClassSmartSpotToggleContainer';
import { classInfoMessages, reservationsOverviewMessages } from './ScheduleDetail.messages';
import './ClassInfoMobile.scss';

function ClassInfoMobile({ canToggleClassSmartSpot, canOnlyToggleNonRecurring, schedule }) {
  const {
    duration,
    isCancelled,
    isDisabled,
    isInThePast,
    reservationsStopped,
    resource,
    scheduleClass,
    scheduleName,
    scheduleId,
    startDateTime,
    smartspotEnabled,
    smartspotEnabledForVenue,
  } = schedule;
  const { resourceName: instructorName } = resource || {};
  const { classId } = scheduleClass || {};

  let message = null;
  if (!isInThePast) {
    if (isCancelled) {
      message = classInfoMessages.isCancelled;
    } else if (isDisabled) {
      message = classInfoMessages.isDisabled;
    } else if (reservationsStopped) {
      message = classInfoMessages.reservationsStopped;
    }
  }
  const canToggleSmartspot = canToggleClassSmartSpot && !isDisabled;
  const smartSpotMessage = smartspotEnabled ? reservationsOverviewMessages.ss.on : reservationsOverviewMessages.ss.off;

  return (
    <div className="class-info-mobile pv-regular ph-regular">
      <div className="class-info-mobile__flex-wrapper">
        <p className="text--md text--semibold text--ellipsis mr-regular mb-0" title={scheduleName}>
          {scheduleName}
        </p>
        {message && <Badge message={message} />}
      </div>
      <p className="text--sm text--light mt-tiny mb-0">
        {instructorName ? (
          <Message message={classInfoMessages.durationAndInstructor} values={{ duration, instructorName }} />
        ) : (
          <Message message={classInfoMessages.duration} values={{ duration }} />
        )}
      </p>
      {smartspotEnabledForVenue && !isInThePast && (
        <ClassSmartSpotStatus
          className="class-info-mobile__ss-status"
          name={`class-smartspot-mobile-${scheduleId}`}
          isEnabled={smartspotEnabled}
          showToggle={canToggleSmartspot}
          canOnlyToggleNonRecurring={canOnlyToggleNonRecurring}
          schedule={schedule}
          {...{ classId, scheduleId, scheduleName, startDateTime, isDisabled }}>
          <Message message={smartSpotMessage} />
        </ClassSmartSpotStatus>
      )}
    </div>
  );
}

ClassInfoMobile.propTypes = {
  canToggleClassSmartSpot: PropTypes.bool,
  canOnlyToggleNonRecurring: PropTypes.bool,
  schedule: PropTypes.shape(schedulePropTypes),
};

export default ClassInfoMobile;
